import styled from '@emotion/styled'

export const ReconciliationSuggestionGroup = styled.ul`
  margin: 16px 0;
`
